class NavItem extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("mouseenter", this.onMouseEvent.bind(this));
    this.addEventListener("mouseleave", this.onMouseEvent.bind(this));
  }

  onMouseEvent(event) {
    if (event.type === "mouseenter") {
      this.setAttribute("open", true);
    } else if (event.type === "mouseleave") {
      this.removeAttribute("open");
    } else {
      return;
    }
  }
}
customElements.define("nav-item", NavItem);
